module.exports = __webpack_public_path__ + "static/img/04.746da51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/11/04.jpg
// module id = d7xv
// module chunks = 2